import ApiService from './ApiService'

export default class LocalisationService {
    apiService

    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_LOCALISATION_API)
    }

    get({ lang, cc, api_key }) {
        return this.apiService
            .get('/14', {
                key: api_key,
                lang,
                cc,
            })
    }
}
